import { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Landing } from './routes/Landing.js';
import { NotFound } from './routes/NotFound.js';

/**
 * Las landings de destino se cargan aparte.
 *
 * Son las unicas paginas que necesitan Firestore, y arrastran con el todo el
 * SDK. Si viajaran en el mismo paquete que la pagina de venta, cada visita a
 * la portada descargaria medio megabyte de codigo que no va a ejecutar.
 *
 * El reparto tambien beneficia al otro lado: quien escanea un codigo esta en
 * la calle, con una conexion peor que la de un escritorio, y no descarga la
 * pagina de precios.
 */
const HostedPage = lazy(() =>
  import('./routes/HostedPage.js').then((m) => ({ default: m.HostedPage })),
);

/*
 * Los legales, por el mismo motivo y con menos ceremonia.
 *
 * Son tres paginas de texto corrido que casi nadie abre, pero que tienen que
 * existir y estar completas. Metidas en el paquete de la portada sumarian unos
 * kilobytes a cada visita para nada; aparte, se descargan solo cuando alguien
 * pulsa el enlace del pie.
 *
 * No llevan Suspense con esqueleto: no esperan ningun dato, solo el modulo, y
 * pintar un armazon falso durante 80 milisegundos se ve peor que no pintar
 * nada.
 */
const Terminos = lazy(() =>
  import('./routes/Terminos.js').then((m) => ({ default: m.Terminos })),
);
const Privacidad = lazy(() =>
  import('./routes/Privacidad.js').then((m) => ({ default: m.Privacidad })),
);
const Reembolsos = lazy(() =>
  import('./routes/Reembolsos.js').then((m) => ({ default: m.Reembolsos })),
);

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/p/:type/:codeId"
          element={
            <Suspense
              /*
                El mismo esqueleto que pinta la propia página mientras busca
                el contenido. Va escrito aquí y no importado de HostedPage
                porque ese módulo viaja aparte: importarlo para la espera lo
                traeria antes de tiempo y no habria espera que amenizar.
              */
              fallback={
                <main className="destino">
                  <div className="destino__lienzo">
                    <div className="destino__hueso destino__hueso--disco" />
                    <div className="destino__hueso destino__hueso--titulo" />
                    <div className="destino__hueso destino__hueso--linea" />
                    <div className="destino__hueso destino__hueso--fila" />
                    <div className="destino__hueso destino__hueso--fila" />
                  </div>
                </main>
              }
            >
              <HostedPage />
            </Suspense>
          }
        />
        <Route
          path="/terminos"
          element={
            <Suspense fallback={null}>
              <Terminos />
            </Suspense>
          }
        />
        <Route
          path="/privacidad"
          element={
            <Suspense fallback={null}>
              <Privacidad />
            </Suspense>
          }
        />
        <Route
          path="/reembolsos"
          element={
            <Suspense fallback={null}>
              <Reembolsos />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
